import { ChangeEvent, useCallback, useState } from 'react';

export const useInput = (initialValue: any, validator: (v: any) => boolean) => {
  const [value, setValue] = useState(initialValue);

  const onChangeHandler = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const {
        target: { value },
      } = e;
      if (validator(value)) setValue(value);
    },
    [validator, setValue],
  );

  const onResetHandler = useCallback(() => setValue(initialValue), [initialValue]);

  return {
    value,
    onChangeHandler,
    onResetHandler,
  };
};
